import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild, ViewRef } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

import { ChatWithBot, OpenAiResponse, PersonType, Run } from 'app/core/community/models/gpt-response.model';
import { ChatService } from 'app/core/community/_service/chat-service.service';
import { ChatThreadDTO } from 'app/core/community/models/chatThread.model';


@Component({
  standalone: false,
  selector: 'app-customer-support',
  templateUrl: './customer-support.component.html',
  styleUrls: ['./customer-support.component.scss'],
})
export class CustomerSupportComponent implements OnInit{
  customerSupportForm!: FormGroup;
  chatConversation: ChatWithBot[] = [];
  responseLoading = false;
  botName: PersonType = 'Fyffes Support';
  apiResponse :OpenAiResponse ;

  @ViewChild('chatRef', { read: ElementRef }) chatRef!: ElementRef;
	threadId :string
  constructor(
    private chatService: ChatService,
    private formBuilder: FormBuilder,
	private changeDetectorRef: ChangeDetectorRef,
  ) {
    this.createForm();
  }
	ngOnInit(): void {
		this.chatConversation = [];
		const username = localStorage.getItem('user');
		this.chatService.getThreads(username)                
		.subscribe(threadList => {
			if(threadList.length > 0){
				this.threadId = threadList[0].threadId;
				this.loadAllChats(threadList[0].threadId);
			}
			else
			{
				const threadI = this.chatService.createThread();			
				threadI.subscribe((resp ) =>
					{
						this.threadId = resp.id;
						let thread : ChatThreadDTO =  new ChatThreadDTO();
						thread.threadId = resp.id;
						thread.username = username;
						this.loadAllChats(resp.id);
						this.chatService.postThread(thread)					
						.subscribe(isRegistered => {
								if (isRegistered) {
			
								} else {
		
								}
						});

			});
				

			}
		});

	//	let threadId :string = 'thread_MrlqT18upRU0v9vNggt69m3f';
	//	this.loadAllChats(threadId);
	}
	// blurTEST(){
	// 	let threadId :string = 'thread_MrlqT18upRU0v9vNggt69m3f';
	// 	this.loadAllChats(threadId);
	// }


	loadAllChats(threadId :string)
	{
		this.chatService.listMessages(threadId).subscribe(
			(list : any)=>{
				list.data.reverse().forEach(element => {
					if(element.role == 'assistant')
						{
							this.chatConversation.push({
								person: this.botName,
								response: this.replaceAnotations(element.content[0].text.value,element.content[0].text.annotations) ,
								fromUser: false,
							  });
						}
						else
						{
							this.chatConversation.push({
								person: 'You',
								response: element.content[0].text.value,
								fromUser: true,
							  });
						}

				});
				this.responseLoading = false;

				  this.updateDOM();
				  this.scrollChat();
			}
		);

	}

  sendChatGptRequest(): void {
    const promptText = this.customerSupportForm.get('promptText')!.value;
    if (!promptText) {
      return;
    }

    this.responseLoading = true;
    this.chatConversation.push({
      person: 'You',
      response: promptText,
      fromUser: true,
    });
    this.customerSupportForm
      .get('promptText')
      ?.setValue('', { emitEvent: false });
    this.scrollChat();


			this.chat(promptText,this.threadId);
		
		
  }

  chat( message: string, threadId: string)
  {
	  this.apiResponse = new OpenAiResponse();
	  this.chatService.createMessage(threadId,message).subscribe(
		  (resp ) =>{
			  let runresp : Run = new Run();
			  this.chatService.runAssistant(threadId).subscribe(
				  (apiResponse : any) => {
					  runresp.id = apiResponse.id;
					  runresp.status = apiResponse.status;
					  runresp.thread_id = apiResponse.thread_id;

							   new Promise(
								  (resolve) =>
									  {
										  setTimeout(resolve, 1000);
									  }
							  );
							  if (['queued', 'in_progress', 'cancelling'].includes(runresp.status)) {
								  this.retrieve(runresp);
							  }
							  else if(runresp.status ==='completed')
							  {
								  this.chatService.listMessages(runresp.thread_id).subscribe(
									  (list : any)=>{
										  this.responseLoading = false;
										  this.chatConversation.push({
											  person: this.botName,
												response: this.replaceAnotations(list.data[0].content[0].text.value,list.data[0].content[0].text.annotations),
											  fromUser: false,
											});
											this.updateDOM();
											this.scrollChat();
									  }
								  );
							  }





				  }
			  );
		  }
	  );
  }

  private retrieve(runresp: Run) {
	if (['queued', 'in_progress', 'cancelling'].includes(runresp.status)) {
		this.chatService.runRetrieve(runresp.thread_id, runresp.id).subscribe(
			(retrieveResponse: any) => {
				runresp.id = retrieveResponse.id;
				runresp.status = retrieveResponse.status;
				runresp.thread_id = retrieveResponse.thread_id;
				new Promise(
					(resolve) => {
						setTimeout(resolve, 1000);
					}
				);

				if (['queued', 'in_progress', 'cancelling'].includes(runresp.status)) {
					this.retrieve(runresp);
				}
				else if(runresp.status ==='completed')
					{
						this.chatService.listMessages(runresp.thread_id).subscribe(
							(list : any)=>{
								this.responseLoading = false;
								this.chatConversation.push({
									person: this.botName,
									response: list.data[0].content[0].text.value,
									fromUser: false,
								  });
								  this.updateDOM();
								  this.scrollChat();
							}
						);
					}
			}
		);
	}
}

private updateDOM() {
	if (this.changeDetectorRef && !(this.changeDetectorRef as ViewRef).destroyed) {
		this.changeDetectorRef.detectChanges();
	}
}
  private scrollChat(): void {
    requestAnimationFrame(() => {
      const chatBody = this.chatRef.nativeElement as HTMLElement;
      chatBody.scrollTo({ top: chatBody.scrollHeight, behavior: 'smooth' });
    });
  }

  private createForm(): void {
    this.customerSupportForm = this.formBuilder.group({
      promptText: [''],
    });
	}
	
	public	replaceAnotations(input: string, annotations: Array<any>): string {
		let counter = 1;  // Contador para los números consecutivos
		var re = /【/gi; 	
		var re2 = /】/gi; 		
		var newstr = input.replace(re, "[");
		var newstr2 = newstr.replace(re2, "]");
		
		return newstr2.replace(/\[.*?†source.*?\]/g, () => ``);
	
	}

}
